<template>
  <TeamGrid :items="teamItems" grid-class="team-stats-grid" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import TeamGrid from '@/components/TeamGrid.vue';

const store = useGameStore();
const stats = computed(() => store.gameStats);

const teamItems = computed(() => [
  { icon: '📥', label: 'Web Scrapers', value: stats.value.infrastructure.webScraper || 0 },
  { icon: '🗄️', label: 'Databases', value: stats.value.infrastructure.database || 0 },
  { icon: '💎', label: 'Clean Data APIs', value: stats.value.infrastructure.cleanDataApi || 0 },
  { icon: '🔗', label: 'Model APIs', value: stats.value.infrastructure.modelApi || 0 },
  { icon: '📡', label: 'IoT Sensors', value: stats.value.infrastructure.iotSensor || 0 },
  { icon: '🧹', label: 'Data Cleaners', value: stats.value.infrastructure.dataCleaner || 0 },
  { icon: '⚙️', label: 'ETL Pipelines', value: stats.value.infrastructure.etlPipeline || 0 },
  { icon: '🌊', label: 'Streaming Systems', value: stats.value.infrastructure.streamingSystem || 0 },
  { icon: '🏪', label: 'Feature Stores', value: stats.value.infrastructure.featureStore || 0 },
  { icon: '🔧', label: 'Feature Pipelines', value: stats.value.infrastructure.featurePipeline || 0 },
  { icon: '🧠', label: 'Training Pipelines', value: stats.value.infrastructure.trainingPipeline || 0 },
  { icon: '📋', label: 'Model Registries', value: stats.value.infrastructure.modelRegistry || 0 },
  { icon: '🤖', label: 'AGI Clusters', value: stats.value.infrastructure.agiCluster || 0 },
  { icon: '🔧', label: 'Data Engineers', value: stats.value.personnel.dataEngineer || 0 },
  { icon: '🤖', label: 'ML Engineers', value: stats.value.personnel.mlEngineer || 0 },
  { icon: '🧑‍🔬', label: 'AI Researchers', value: stats.value.personnel.aiResearcher || 0 },
  { icon: '🧠', label: 'Reasoning Specialists', value: stats.value.personnel.reasoningSpecialist || 0 },
  { icon: '🛡️', label: 'AGI Safety Researchers', value: stats.value.personnel.agiSafetyResearcher || 0 },
].filter(item => item.value > 0));
</script> 